import * as angular from "angular";
import template from "./array-table.html";
import { arrayTableAddOn } from "./array-table-add-on";
import schemaArrayItemModal from "./schema-array-item-modal/schema-array-item-modal";
import schemaFormArrayTable from "./schema-form-array-table";
import "./array-table.less";

export default angular
	.module("vesl.extensions.json-schema.array-table", [
		"schemaForm",
		schemaArrayItemModal,
		schemaFormArrayTable
	])
	.run(["$templateCache", function($templateCache) {
		$templateCache.put("./array-table.html", template);
	}])
	.config(arrayTableAddOn)
	.name;
